module.exports = __webpack_public_path__ + "img/aipocalypse.3435f16c.jpg";